export default __webpack_public_path__ + "02_RequestCommentary.cb7a8ee6.png";